// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { Loading } from '@carbon/react';
import styled from '@emotion/styled';

import { API_STATIC_BLOCKS } from 'Constants';
import useFetch from 'Hooks/useFetch';

const StyledStaticBlock = styled.div`
  table, div[dir="ltr"] {
    overflow-x: scroll;
  }
`;

const StyledLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StaticBlock = ({ id }) => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const fetcher = useFetch();

  useEffect(() => {
    getStaticBlock();
  }, []);

  const getStaticBlock = () => {
    setIsLoading(true);
    fetcher(`${ API_STATIC_BLOCKS }/${ id }`)
      .then(data => setContent(data))
      .finally(() => setIsLoading(false));
  };

  return (
    <StyledStaticBlock>
      { isLoading ? (
        <StyledLoading>
          <Loading active withOverlay={ false } />
        </StyledLoading>
      ) : <div dangerouslySetInnerHTML={ { __html: content?.content } } /> }
    </StyledStaticBlock>
  );
};

StaticBlock.propTypes = {
  id: string,
};

export default StaticBlock;
